import { Injectable } from '@angular/core';

@Injectable()
export class MstarCategoryColors {
	public readonly COLORS: any = {
		$FOCA$CI$$: '#719e32',
		$FOCA$CS$$: '#2f7ed8',
		$FOCA$EB$$: '#0d233a',
		$FOCA$EM$$: '#8bbc21',
		$FOCA$FB$$: '#910000',
		$FOCA$GL$$: '#1aadce',
		$FOCA$HY$$: '#492970',
		$FOCA$IH$$: '#f28f43',
		$FOCA$IP$$: '#77a1e5',
		$FOCA$LB$$: '#c42525',
		$FOCA$LG$$: '#012051',
		$FOCA$LV$$: '#003594',
		$FOCA$MB$$: '#005eb8',
		$FOCA$NT$$: '#006747',
		$FOCA$SB$$: '#009639',
		$FOCA$TV$$: '#772654',
		$FOCA$TW$$: '#c2157b',
		$FOCA$UB$$: '#50325b',
		$FOCA$XS$$: '#455560'
	};
}
